module.exports = __webpack_public_path__ + "static/media/error-404.7dd2f170.svg";